import { Component } from '@angular/core';
import { CapturumBuilderActionService } from '@capturum/builders/core';
import { FormSaverService } from '@capturum/builders/form-renderer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PowerBIManageDetailsBase } from '../../base/power-bi-manage-details-base.class';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cap-pbi-clients-manage-details',
  templateUrl: './clients-manage-details.component.html',
  styleUrls: ['./clients-manage-details.component.scss'],
})
export class CapturumPowerBIClientsManageDetailsComponent extends PowerBIManageDetailsBase {
  public key: string = 'form_edit_power_bi_client';
  private subscription: Subscription = new Subscription();


  constructor(
    protected formSaverService: FormSaverService,
    protected config: DynamicDialogConfig,
    protected dialogRef: DynamicDialogRef,
    protected actionService: CapturumBuilderActionService,
  ) {
    super(formSaverService, config, dialogRef, actionService);
  }

  public ngOnInit(): void {
    this.subscription.add(
      this.dialogRef.onClose.subscribe(() => {
          this.actionService.broadcastActionExecuted(this.config?.data?.action, this.item, null);
        },
      ),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
